<template>
    <div class="row main-content" id="top">
        <priceworkflow-sidebar
            :submission="submission"
        ></priceworkflow-sidebar>
        <div class="col-md-10" id="standard-styling" style="padding-left:50px;">
            <form @submit.prevent="savePromoDetails">
                <h2>VOLUME BASED SUBMISSIONS</h2>
                <div class="col-md-3" style="padding-left:0;">
                    <p>
                        <strong>SELECT COMPANY:</strong>
                        <autocomplete
                            :source="companyList"
                            placeholder="Select Company..."
                            @selected="selectCompany">
                        </autocomplete>
                    </p>
                </div>
                <br>
                <div class="col-md-10" style="padding-left:0;">
                    <p>
                        <strong>ORDER NUMBER:</strong> <em>i.e.S1234567</em>
                        <ul class="col-md-10" style="list-style-type:none;display:flex;flex-wrap;padding-left:0;">
                            <li class="col-md-2" v-for="i in 5" :key="i" style="padding-left:0;">
                                <input
                                    type="text"
                                    :name="'ord_num['+(i-1)+']'"
                                    class="input"
                                    id="ordNumInputs"
                                    v-model="ordNums[i-1]"
                                    :placeholder="'Order #'+i"
                                    style="width:95%;"
                                />
                            </li>
                        </ul>
                    </p>
                </div>
                <br>
                <div class="col-md-3" style="padding-left:0;">
                    <p>
                        <strong>INITIAL ORDER VOLUME:</strong>
                        <admin-select v-model="orderVolume">
                            <option></option>
                            <option value="2500">$2,500</option>
                            <option value="5000">$5,000</option>
                            <option value="10000">$10,000</option>
                        </admin-select>
                    </p>
                </div>
                <br />
                <br />
                <button class="btn-round-red" type="submit">SUBMIT TO PRICING TEAM ></button>
            </form>
        </div>
    </div>
</template>

<script>
import Autocomplete from "vuejs-auto-complete";
import {mapState} from "vuex";
export default {
    components: {
        Autocomplete
    },
    data() {
        return {
            companyList: [],
            companySelection: "",
            i: 5,
            orderVolume: "",
            ordNums: ["","","","","","","","","",""],
            submission: {}
        }
    },
    props: ['ppId'],
    computed: {
        ...mapState({ user: state => state.user })
    },
    created() {
        axios.get(`/api/getCompaniesForAutoComplete`).then(response => {
            this.companyList = response.data;
        });
        axios.get(`/api/getSubmission/${this.ppId}`).then(response => {
            this.submission = response.data;

            this.companySelect = this.submission.cust_id;
            this.orderVolume = this.submission.initial_volume;

            if(this.submission.ord_num != null) {
                let ordNums = this.submission.ord_num.split("|");
                this.ordNums = ordNums;
            }
        });
    },
    methods: {
        savePromoDetails() {
            let data = {
                id: this.ppId,
                custId: this.companySelection,
                ordNums: this.ordNums,
                orderVolume: this.orderVolume,
                requestedById: this.user.id,
            }

            axios.post(`/api/savePromoDetails`, data).then(response => {
                this.$router.push({
                    name: "PriceWorkflowDashboards"
                });
            })
        },
        selectCompany(result) {
            this.companySelection = result.value;
        }
    }
}
</script>
